module.exports = __webpack_public_path__ + "img/trade_phone.04f20815.png";